export const apiUrl = {
    playerposts: 'admin/playerPosts',
    playerDashboard: 'admin/playerDashboard',
    playerBookingList: 'admin/PlayersBookingList',
    addAmenity: 'admin/addAmenities',
    addCity: 'admin/addCities',
    addField: 'admin/addField',
    addFieldSize: 'admin/addFieldsize',
    addGroundType: 'admin/addGroundTypes',
    addMatchType: 'admin/addMatchTypes',
    addPosition: 'admin/addPosition',
    addSponsor: 'admin/addSponsors',
    addToSubscribers: 'admin/addToSubscribers',
    addVersion: 'admin/addVersion',
    gliveStatus: 'admin/gliveStatus',
    gliveAction: 'admin/gliveAction',
    addCountry: 'admin/addcountry',
    addState: 'admin/addstates',
    adminEarning: 'admin/adminEarning',
    blockField: 'admin/blockField',
    blockUnblockData: 'admin/blockUnblockData',

    broadcastMessage: 'admin/broadcastMessage',
    contactDetails: 'admin/contactDetails',
    addContract: 'admin/createContract',
    addAdvertisement: 'admin/createEditAdvertisement',
    addFeature: 'admin/addEditLiveStreams',
    featuredList: 'admin/getLiveStreams',
    addEditAdvertisement: 'admin/addEditAdvertisement',
    addPromoCode: 'admin/createEditPromoCode',
    addOwner: 'admin/createOwnerByAdmin',
    dashBoard: 'admin/dashBoard',
    deleteAmenity: 'admin/deleteAmenities',
    deleteContract: 'admin/deleteContract',
    deleteData: 'admin/deleteData',
    deleteFieldSize: 'admin/deleteFieldSize',
    deleteFieldType: 'admin/deleteFieldType',
    deleteLocality: 'admin/deleteLocality',
    deleteMatchType: 'admin/deleteMatchType',
    deletePosition: 'admin/deletePosition',
    deleteQuery: 'admin/deleteQueries',
    deleteReportedPost: 'admin/deleteReportedPost',
    fieldDetails: 'admin/fieldDetails',
    gameDetails: 'admin/gameDetails',
    getAdRevenueDetails: 'admin/getAdRevenueDatals',
    ads: 'admin/getAds',
    getAdvertisements: 'admin/getAdvertisements',
    publishAd: 'admin/approveAd',
    broadCasts: 'admin/getBroadCast',
    cities: 'owner/citiesList1',
    getCompleteRevenueData: 'admin/getCompleteRevenueData',
    contracts: 'admin/getContracts',
    countries: 'admin/getCountryList',
    getFieldData: 'admin/getFieldData',
    getListing: 'admin/getListing',
    getMailChimpList: 'admin/getMailChimpList',
    owners: 'admin/getOwnerList',
    promoCodes: 'admin/getPromoCode',
    queries: 'admin/getQueries',
    revenueData: 'admin/getRevenueData',
    getSlotsPromotion: 'admin/getSlotsPromotion',
    sponsors: 'admin/getSponsors',
    states: 'admin/getStatesList',
    getSubscribers: 'admin/getSubscribers',
    getGliveQueries: 'admin/getGliveQueries',
    getGAdvertiseQueries: 'admin/getAdQueries',
    getCvQueries: 'admin/getApplyQueries',
    getFieldWithContract: 'admin/getfieldWithContract',
    fieldSizes: 'admin/listFieldSize',
    fieldTypes: 'admin/listFieldType',
    matchTypes: 'admin/listMatchTypes',
    listPickupGames: 'admin/listPicupGames',
    listPlayers: 'admin/listPlayers',
    playersData: 'admin/playersData',
    listReportedPost: 'admin/listReportedPost',
    listVersion: 'admin/listVersion',
    login: 'admin/login',
    pickUpGameCount: 'admin/pickupgameCount',
    postQueries: 'admin/postQueries',
    subscribeMailChimp: 'admin/subscribeMailChimp',
    updateCity: 'admin/updateCity',
    updateCountry: 'admin/updateCountry',
    updateFieldSize: 'admin/updateFieldSize',
    updateFieldType: 'admin/updateFieldType',
    updateMatchType: 'admin/updateMatchType',
    updatePasswordViaLink: 'admin/updatePasswordViaLink',
    updatePlayerProfile: 'admin/updatePlayerProfile',
    updateProfile: 'admin/updateProfile',
    updateState: 'admin/updateState',
    uploadImage: 'admin/uploadImageOrVideo',
    amenities: 'owner/getAmenities',
    positions: 'owner/listPosition',
    checkUsername: 'owner/checkUsername',
    reports: 'admin/getReports',
    playerReport: 'admin/playerReport',
    groundRelatedData: 'owner/groundRelatedData',
    generateReport: 'admin/generateReport',
    getOwnerQueries: 'admin/getOwnerQueries',
    newDashboard: 'admin/newDashboard',
    gameDashboard: 'admin/gameDashboard',
    dashboardGGOvsOGGO: 'admin/dashboardGGOvsOGGO',
    feedDashboard: 'admin/feedDashboard',
    addCamerasToField: 'admin/addCamerasToField',
    fetchReferrals: 'admin/fetchReferrals',
    getGameDetails: 'admin/gameDetails',
    getCurrencies: 'admin/getCurrencies',
    updateGame: 'admin/editGame',
    addEditBrands: 'admin/addEditBrands',
    addEditClubs: 'admin/addEditClubs',
    addEditCurrencies: 'admin/addEditCurrencies',
    verifyOrganizer: 'admin/verifiedOrganizer',
    getRegistrationReport: 'admin/getRegistrationReport',
    getOnlineUsers: 'admin/onlineUsers',
    getAdmins: 'admin/getAdmins',
    addEditAdmin: 'admin/addEditAdmin',
    blockUnblockAdmin: 'admin/blockUnblockData',
    updateGameStatus: 'admin/checkUncheckGame',
    /* New */
    bookingDashboard: 'admin/bookingDashboard',
    newDashboardV2: 'admin/newDashboardV2',
    onlineUsers: 'admin/onlineUsersV2',
    newDashboardV3: 'admin/newDashboardV3',
    // Graph
    registrationGraph: "admin/registrationGraph",
    gameGraph: "admin/gameGraph",
    fieldgraph: "admin/feedGraph",
    bookingGraph: "admin/bookingGraph",
    overallGraph: "admin/overallGraph",
    operationKPIGraph: 'admin/operationKPI',
    marketingDashboard: 'admin/marketingKPI',
    playersKpiDashboard: 'admin/playerKPI',
    playersLatLng: 'admin/playerLocations',
    /* new */

    gameschartgameGraphV2: "admin/gameGraphV2",
    registrationGraphV2: "admin/registrationGraphV2",
    feedGraphV2: "admin/feedGraphV2",
    bookingGraphV2: "admin/bookingGraphV2",
    overallGraphV2: "admin/overallGraphV2",
    registrationGraphV3: "admin/registrationGraphV3",
    overAllOnlineGames: 'admin/onlineGameGraph',

    //tryout
    getClubAccounts: "admin/getClubAccounts",
    getUpcomingTryouts: "admin/getUpcomingTryouts",
    getTryoutDetails: "admin/getTryoutDetails",
    getTryoutPlayerData: "admin/playersData",
    getacceptRejectRequest: "admin/acceptRejectRequest",
    getPastTryouts: "admin/getPastTryouts",
    getlockUnlockPlayer: "admin/lockUnlockPlayer",
    getPlayersTryOuts: "admin/getPlayersTryOuts",
    getapproveDeclineForTryout: "admin/approveDeclineForTryout",
    getsearchclubPlayers: "admin/searchPlayer",
    getaddPlayerstoclub: "admin/addPlayersToClub",
    exportTryOuts: 'admin/getUpcomingTryouts',
    //ggo-reports
    getSearchplayers: "admin/searchPlayer",
    getmarkUnmarkGGO: "admin/markUnmarkGGO",
    getGGOReport: "admin/getGGOReport",
    getAcademyRegisteration: 'admin/getAcademyRegistrations',

    //forgot-password
    getforgotpasswordlink: "player/forgetPassword",

    //target
    getOverallTargetReport: "admin/getOverallTargetReport",

    //stc-online-games
    getstcGames: 'admin/getstcGames',
    getstcGamePlayers: 'admin/getstcGamePlayers',
    pausestcCashOut: 'admin/pausestcCashOut',

    updateFeed: 'admin/updateFeed',
    resolveQuery: 'admin/resolveQuery',
    markUnmarkFeatured: 'admin/markUnmarkFeatured',
    geSuccessStories: 'admin/getSuccessStory',
    manageSuccessStories: 'admin/manageSuccessStory',
    // app dowloads
    getAppDownloads: 'admin/getAppDownloads',
    addEditDownload: 'admin/addEditAppDownloads',
    ediBookingDetails: 'admin/editBookingDetail',
    getFeedCategories: 'admin/getFeedCategories',
    mojtameeAcademyRegisteration: 'admin/academyRegistrations',
    fetchAcademies: 'admin/academies',
    AcademyRegister: 'admin/academy/register',

    //challanges apis
    ChallangesApi: 'admin/saff/challenge?type=',
    moveFeed: 'admin/saff/moveFeed',
    challangeDetails: 'admin/saff/feed?type=',
    updateChallengeStatus: 'admin/saff/feedManage',
    deleteFeed: 'admin/saff/feedDelete',

    // scout app
    scoutLogin: 'scout/login',
    scoutForgotPassword: 'scout/forgotPassword',
    scoutResetStatus: 'scout/resetStatus',
    scoutChangePassword: 'scout/changePassword',
    playersDashboard: 'scout/dashboard',
    playersDashboardHeatmap: 'scout/heatmap',
    playerList: 'scout/playerList',
    getPositions: 'scout/getPositions',
    favouritePlayer: 'scout/favUnfavPlayer',
    playerDetails: 'scout/playerDetails',
    playerPosts: 'scout/playerPosts',
    playerProfileDashboard: 'scout/playerDashboard',
    totmw: 'scout/totmw',
    getCities: "scout/getCities",
    getTOTWdates: "scout/getTOTWdates",
    topRankings: "scout/topRankings",
    getFeeds: "scout/getFeeds",
    searchForFeed: "scout/searchForFeed",
    userData: "scout/userData",
    scoutCategories: "scout/getFeedCategories",

    //club-access
    getUpcomingTryoutsClub: 'scout/getUpcomingTryouts',
    getTryoutDetailsClub: "scout/getTryoutDetails",
    getPastTryoutsClub: "scout/getPastTryouts",
    getplayerListClub: "scout/playerList",
    exportTryOutsClub: 'scout/getUpcomingTryouts',
    getacceptRejectRequestClub: "scout/acceptRejectRequest", 
    getacceptRejectRequestClubOnline: "scout/acceptOnlineRequest",
    removePaymentPendingClub: "scout/removePaymentPending",
    lockUnlockPlayerClub: "scout/lockUnlockPlayer", 
    getsearchclubPlayersClub: "scout/searchPlayer",
    addPlayersToClub: "scout/addPlayersToClub",
    getJoinedTryouts: "scout/getJoinedTryouts",



    //Scout chat
    getRooms: "scout/getRooms",
    getMessages: "scout/getMessages",
    sendMessage: "scout/sendMessage"


};


